/* eslint-disable react/sort-comp */
/* eslint-disable no-console */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-cycle */
import React, { Component } from "react";
import { t } from "@lingui/macro";
import { withI18n } from "@lingui/react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import OutsideClickHandler from "react-outside-click-handler";
import { DOMAIN_REGION } from "../../constants";
import * as CATEGORY from "../../constants/searchCategories";
import toQueryString from "../../functions/toQueryString";
import { Api } from "../../functions/fetchFromApi";
import debounce from "../../functions/debounce";
import classNames from "../../functions/classNames";
import reverseUrl from "../../functions/reverseUrl";
import getDomainRegion from "../../functions/region/getDomainRegion";
import { getProductLink } from "../../functions/getProductLink";
import sendEvent from "../../functions/analytics";
import { renewUrlParamInCookies } from "../../functions/urlParamsToCookiesUtils";
import getCurrentLanguage from "../../functions/languages/getCurrentLanguage";
import useRemoteConfig from "../../functions/useRemoteConfig";
import { SpinnerCircle } from "../Spinner";
import Checkbox from "../Checkbox";
import SearchItem from "./SearchItem";
import "./Search.css";

/**
 * Icon imports
 */
import svgSearch from "./assets/search.svg";
import Button from "../Button";

function PartnerCheckbox({ checked, onChange, label }) {
  return <Checkbox label={label} checked={checked} onChange={onChange} />;
}

/**
 * Search bar
 * @param {Object} $
 * @param {String} $.className - additional className to the root component
 * @param {String} $.theme
 * @param {String} $.placeholder - placeholder for input field
 */
const SearchWithRemoteConfig = props => {
  const remoteConfig = useRemoteConfig(); // Используем хук

  return <Search {...props} remoteConfig={remoteConfig} />;
};

class Search extends Component {
  /**
   * Inner state of the component
   * @prop {String} searchValue - current search field value
   * @prop {String} lastrequest - last field value was sent to server
   * @prop {Array} results - search results
   * @prop {Boolean} isLoading - if some requests is in progres
   * @prop {Boolean} resultsVisible - show/hide results
   * @prop {Boolean} notFound - if results are empty
   * @prop {String} error - error message
   */
  state = {
    searchValue: "",
    lastRequest: "",
    isLoading: false,
    notFound: false,
    resultsVisible: false,
    results: [],
    isCheckboxChecked: false,
    error: null,
  };

  constructor(props) {
    super(props);
    this.search = this.search.bind(this);
    this.searchDebounced = debounce(this.search, 400);
  }

  componentDidMount() {
    const { remoteConfig } = this.props;

    const savedCheckboxState = sessionStorage.getItem("isCheckboxChecked");

    if (savedCheckboxState !== null) {
      this.setState({ isCheckboxChecked: savedCheckboxState === "true" });
    } else if (remoteConfig?.partnerSerachCheckboxEnabled !== undefined) {
      this.setState({ isCheckboxChecked: remoteConfig.partnerSerachCheckboxEnabled });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.remoteConfig?.partnerSerachCheckboxEnabled !==
      this.props.remoteConfig?.partnerSerachCheckboxEnabled
    ) {
      const savedCheckboxState = sessionStorage.getItem("isCheckboxChecked");

      if (savedCheckboxState === null) {
        this.setState({
          isCheckboxChecked: this.props.remoteConfig?.partnerSerachCheckboxEnabled ?? false,
        });
      }
    }
  }

  /**
   * Sends request to the server for getting search results
   * Updating state of component with these results
   * @param {String} payload - request for search
   */
  search(query) {
    if (!query || query.length < 3) {
      this.setState({ results: [], isLoading: false });
      return;
    }

    try {
      this.setState({ isLoading: true, error: null });

      sendEvent("track", "products_searched", { query });

      const { match, currency } = this.props;
      const lang = getCurrentLanguage(match.params.lang);

      Api.get(
        `/api/v2/search/?${toQueryString({
          lang,
          query,
          currency,
          region: getDomainRegion(DOMAIN_REGION),
          preorder: true,
        })}`,
        { lang },
      )
        .then(({ data: { results = [] } = {} }) => {
          renewUrlParamInCookies("affam");
          renewUrlParamInCookies("sub_id");
          renewUrlParamInCookies("coupon");

          if (this.state.searchValue.length > 2) {
            const filteredResults = results.filter(
              item => item.type !== CATEGORY.CITIES || item.available,
            );
            this.setState({
              isLoading: false,
              lastRequest: query,
              notFound: !results.length || !filteredResults.length,
              results: filteredResults,
            });
          }
        })
        .catch(error => {
          console.error("Search error:", error);
          this.setState({
            isLoading: false,
            error: this.props.i18n._(t`Произошла ошибка при поиске. Пожалуйста, попробуйте позже.`),
          });
        });
    } catch (error) {
      console.error("Search error:", error);
      this.setState({
        isLoading: false,
        error: this.props.i18n._(t`Произошла ошибка при поиске. Пожалуйста, попробуйте позже.`),
      });
    }
  }

  handleCheckboxChange = event => {
    const isChecked = event.target.checked;

    this.setState({ isCheckboxChecked: isChecked });

    sendEvent("track", isChecked ? "partner_search_checkbox_on" : "partner_search_checkbox_off");

    sessionStorage.setItem("isCheckboxChecked", isChecked);
  };

  /**
   * Tracks value stored in the input
   * @param {Event} $
   * @param {Element} $.target - input element
   */
  handleChange = ({ target }) => {
    const searchValue = target.value;
    this.setState({ searchValue });

    if (searchValue.trim().length >= 3) {
      this.setState({ isLoading: true });
      this.searchDebounced(searchValue);
    } else {
      this.setState({ results: [], notFound: false, isLoading: false });
    }
  };

  handleSearchClick = () => {
    const { searchValue } = this.state;
    if (searchValue.trim().length >= 3) {
      this.setState({ isLoading: true });
      this.search(searchValue);
    }
  };

  /**
   * Handles keys
   * Goes to a page of the first city in results/first result if 'enter' pressed
   * @param {Event} $
   * @param {String} $.key - key id
   */
  handleKeyboard = ({ key }) => {
    if (key === "Enter") {
      const { results } = this.state;
      let item = results[0];

      for (let i = 0; i < results.length; i += 1) {
        if (results[i].type === CATEGORY.CITIES) {
          item = results[i];
          break;
        }
      }

      if (item) {
        const url = this.generateUrl(item.type, item);
        if (url) {
          window.location.assign(url);
          sendEvent("track", "search_result_clicked", {
            type: item.type,
            id: item.id,
          });
        }
      }
    }
  };

  /**
   * Generates url for search result
   * @param {String} category - result category
   * @param {Object} item - description of the result
   * @return {String|Null}
   */
  generateUrl(category, item) {
    const {
      match: { params: urlParams },
    } = this.props;
    const lang = item.locale || getCurrentLanguage(urlParams.lang);
    let type = category;
    let params;

    switch (category) {
      case CATEGORY.TOURS:
        return getProductLink(lang, item);
      case CATEGORY.ATTRACTIONS:
        type = "attraction-simple";
        params = {
          ...item,
          attractionId: item.id,
          attractionSlug: item.slug,
          lang,
        };
        break;
      case CATEGORY.CITIES:
        params = {
          ...item,
          cityId: item.id,
          citySlug: item.slug,
          lang,
        };
        break;
      default:
        return "";
    }

    try {
      return reverseUrl(type, params);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return null;
    }
  }

  render() {
    const {
      className,
      theme,
      themes,
      placeholder,
      i18n,
      remoteConfig,
      isMainPage = false,
    } = this.props;
    const {
      searchValue,
      isLoading,
      results,
      notFound,
      lastRequest,
      resultsVisible,
      isCheckboxChecked,
      error,
    } = this.state;

    let content;
    if (error) {
      content = <SearchItem withoutLink category="error" title={i18n._(t`Ошибка`)} text={error} />;
    } else if (notFound) {
      content = (
        <SearchItem
          withoutLink
          category={CATEGORY.NOT_FOUND}
          title={i18n._(t`Ничего не найдено`)}
          text={i18n._(t`По запросу "${lastRequest}" ничего не найдено`)}
        />
      );
    } else {
      content = results.map((item, index) => {
        const url = this.generateUrl(item.type, item);
        return url ? (
          <SearchItem
            key={`${item.type}-${item.id}-${index}`}
            link={url}
            title={item.type === CATEGORY.TOURS ? item.title : item.name}
            text={
              (item.city ? `${item.city.name}, ` : ``) + (item.country ? item.country.name : ``)
            }
            category={item.type}
            searchWords={lastRequest}
            currencyCode={item.currencyCode}
            price={item.price}
            isCheckboxChecked={isCheckboxChecked}
            isMainPage={isMainPage}
          />
        ) : null;
      });
    }

    const { partnerSearchLabel, partnerSearchCheckboxVisible } = remoteConfig || {};

    return (
      <div
        className={classNames(
          "Search",
          resultsVisible && "Search--touched",
          resultsVisible && searchValue.length && "Search--filled",
          resultsVisible && (results.length || notFound || error) && "Search--results-visible",
          theme && `Search--${theme}`,
          themes && themes.map(themeclassName => `Search--${themeclassName}`),
          className,
        )}
        role="search"
        aria-label={i18n._(t`Поиск`)}
      >
        <OutsideClickHandler onOutsideClick={() => this.setState({ resultsVisible: false })}>
          <div className="Search__row">
            {theme !== "big" && isLoading && (
              <SpinnerCircle className="Search__icon" theme="accent" />
            )}
            <img src={svgSearch} alt="search" />
            <input
              className="Search__input"
              type="text"
              placeholder={placeholder || i18n._(t`Find on WeGoTrip`)}
              value={searchValue}
              aria-label={i18n._(t`Search`)}
              aria-expanded={resultsVisible}
              aria-controls="search-results"
              onChange={this.handleChange}
              onKeyPress={this.handleKeyboard}
              onFocus={() => {
                this.setState({ resultsVisible: true });
                sendEvent("track", "click_on_search_input");
              }}
            />
            {theme === "big" && (
              <Button
                className="Search__search-button"
                theme="accent-full"
                size="L"
                disabled={isLoading}
                aria-label={i18n._(t`Search`)}
                onClick={this.handleSearchClick}
              >
                {isLoading ? <SpinnerCircle theme="accent" /> : i18n._(t`Search`)}
              </Button>
            )}
          </div>
          <div
            className="Search__results"
            id="search-results"
            role="listbox"
            aria-label={i18n._(t`Результаты поиска`)}
          >
            {resultsVisible ? content : null}
          </div>
        </OutsideClickHandler>
        {theme === "big" && partnerSearchCheckboxVisible && (
          <PartnerCheckbox
            checked={isCheckboxChecked}
            label={partnerSearchLabel}
            onChange={this.handleCheckboxChange}
          />
        )}
      </div>
    );
  }
}

export default connect(({ currencies: { currentCurrency } }) => ({ currency: currentCurrency }))(
  withI18n()(withRouter(SearchWithRemoteConfig)),
);
